import React, { forwardRef } from "react";
import Select2 from "react-select2-wrapper";

const Select2Wrapper = forwardRef((props, ref) => (
  <Select2 {...props} ref={ref} />
));

export default Select2Wrapper;
